<template>
  <div class="template-d">
    <img
      class="search"
      src="@images/templateD/search.svg"
      @click.stop="searchClick"
    />
    <div class="section-container">
      <img src="@images/templateD/attendee.png" alt="" />
      <div class="item-container">
        <div class="item-content-bg attendee">
          <div
            class="item-content"
            v-for="(itemContainer, index) in attendeeData"
            :key="index"
            :style="{ marginTop: index > 0 ? '0.41rem' : '' }"
          >
            <template v-for="item in itemContainer">
              <img
                v-if="item.icon"
                class="item"
                :key="item.id"
                @click.stop="handleClick(item)"
                :src="item.icon"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <img src="@images/templateD/experts.png" alt="" />
      <div class="item-container">
        <div class="item-content-bg h ml41">
          <div
            class="item-content"
            v-for="(item, index) in expertsData"
            :key="index"
          >
            <img
              v-if="item.icon"
              class="item"
              :key="item.id"
              @click.stop="handleClick(item)"
              :src="item.icon"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <img src="@images/templateD/exhibitor.png" alt="" />
      <div class="item-container">
        <div class="item-content-bg h ml41">
          <div
            class="item-content"
            v-for="(item, index) in exhibitorData"
            :key="index"
          >
            <img
              v-if="item.icon"
              class="item"
              :key="item.id"
              @click.stop="handleClick(item)"
              :src="item.icon"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <img src="@images/templateD/other.png" alt="" />
      <div class="item-container">
        <div class="item-content-bg h ml41">
          <div
            class="item-content"
            v-for="(item, index) in otherData"
            :key="index"
          >
            <img
              v-if="item.icon"
              class="item"
              :key="item.id"
              @click.stop="handleClick(item)"
              :src="item.icon"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <img src="@images/templateD/footer.png" alt="" />
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {}
  },
  computed: {
    attendeeData () {
      return this.data.slice(0, 9).reduce((data, cur, index) => {
        const arrIndex = parseInt(index / 3)
        if (!data[arrIndex]) data.push([])
        data[arrIndex].push(cur)
        return data
      }, [])
    },
    expertsData () {
      return this.data.slice(9, 11)
    },
    exhibitorData () {
      return this.data.slice(11, 13)
    },
    otherData () {
      return this.data.slice(13)
    }
  },
  methods: {
    searchClick () {
      window.location.href =
        'https://schedule.docbook.com.cn/retrieval?meeting_id=63038&keyword='
    },
    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          let targetUrl = item.content_url
          // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
          const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(targetUrl)
          if (isDocbookUrl && this.$route.query.uid && this.$route.query.platform) {
            targetUrl = os.appendQuery(targetUrl, {
              platform: this.$route.query.platform,
              uid: this.$route.query.uid
            })
          }
          if (os.isPC()) {
            if (os.isInWechatMiniProgram()) {
              //   window.location.href = targetUrl
              window.go(targetUrl)
            } else {
              window.open(targetUrl)
            }
          } else {
            // window.location.href = targetUrl
            window.go(targetUrl)
          }
        }
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.template-d {
  padding: 0 0.43rem;
  padding-top: 0.41rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0522a5 url(~@images/templateD/bottom-bg.png) no-repeat bottom
    right;
  background-size: contain;
  .search {
    width: 100%;
    cursor: pointer;
  }

  // background: #0522a5;

  .section-container {
    margin-top: 0.41rem;
    width: 100%;
    display: flex;
    flex-direction: column;

    > img {
      height: 1.7rem;
    }

    .item-container {
      border-radius: 0.16rem;
      background: rgba(255, 255, 255, 0.3);
      position: relative;
      top: -0.26rem;
      margin-left: -0.16rem;
      padding: 0.16rem;

      .item-content-bg {
        padding: 0.74rem 0.51rem 0.62rem 0.51rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
        border-radius: 0.16rem;

        .item-content {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .item {
            flex: 1;
            width: 0;
            cursor: pointer;

            &.item:not(:first-child) {
              margin-left: 0.62rem;
            }
          }
        }

        &.h {
          flex-direction: row;
        }

        &.ml41 {
          .item-content:not(:first-child) {
            margin-left: 0.41rem;
          }
        }

        &.ml62 {
          .item-content:not(:first-child) {
            margin-left: 0.62rem;
          }
        }
      }
    }
  }

  .bottom {
    width: 100%;
    > img {
      width: 100%;
    }
  }
}
</style>
